// extracted by mini-css-extract-plugin
export default {"safest-places":"SafestPlaces_safest-places__7BFLP","contacts-wrap":"SafestPlaces_contacts-wrap__ORIlf"};